import { object, ObjectSchema, ref, string } from 'yup';

import { FormErrorMessage } from '~/constants/messages';
import { PasswordPolicy, passwordSchema } from '~/utils/password';

import { Fields } from './types';

export const validationSchema = (policy: PasswordPolicy): ObjectSchema<Fields> =>
  object({
    password: passwordSchema(policy).required(FormErrorMessage.required),
    passwordConfirmation: string()
      .label('パスワード（確認）')
      .required(FormErrorMessage.required)
      .oneOf([ref('password')], FormErrorMessage.passwordMismatch),
  });
